module.exports = __webpack_public_path__ + "img/jmb-logo-horizontal-reverse.9e620c1a.png";